import { useLayoutEffect } from 'react';
import cc from 'classcat';
import { isMobile } from 'utils/is-mobile';
import { addQuery } from 'components/QueryRoute';
import { useSearchParams } from 'hooks/useSearchParams';
import { useCustomHistory } from 'newhooks/generic/useCustomHistory';
import './index.less';

type TAdvancedFiltersProps = {
  queryKey: string;
  filterItems: {
    key: string;
    title: string;
  }[];
  className?: string;
};

export const AdvancedFilters = ({
  queryKey,
  filterItems,
  className
}: TAdvancedFiltersProps) => {
  const { history, push } = useCustomHistory();
  const { [queryKey]: queryValue } = useSearchParams();

  const handleFilterClick = (
    value: (typeof filterItems)[0]['key'],
    replace?: boolean
  ) => {
    if (replace) {
      history.replace(addQuery({ [queryKey]: value }));
    } else {
      push(addQuery({ [queryKey]: value }));
    }
  };

  useLayoutEffect(() => {
    if (!queryValue) {
      handleFilterClick(filterItems[0].key, true);
    }
  }, [queryValue]);

  return (
    <div
      className={cc([
        'advancedFilters',
        {
          [`advancedFilters__${className}`]: className,
          [`advancedFilters--mobile`]: isMobile()
        }
      ])}
    >
      {filterItems.map(item => (
        <span
          onClick={() => handleFilterClick(item.key)}
          className={cc([
            'advancedFilters__item',
            {
              'advancedFilters__item--active': queryValue === item.key,
              'advancedFilters__item--mobile': isMobile()
            }
          ])}
          key={item.key}
        >
          {item.title}
        </span>
      ))}
    </div>
  );
};
